import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Content from "../../commons/components/content"
import UsersScreen from "./UsersScreen/usersScreen";
import EditUserScreen from "./EditUserScreen/editUserScreen";

import { usersResetState } from '../../store/actions/usersActions';

function Users(props) {
    const { showUsers, showEditUser } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(usersResetState());
    }, []);

    return (
        <Content>
            {showUsers ? <UsersScreen /> : null}
            {showEditUser ? <EditUserScreen /> : null}
        </Content>
    )
}

export default Users
